export default __webpack_public_path__ + "static/step4-dbe46eccc1487e6dc72e5221d1e9d8e3.jpg";